import React, { useState } from 'react'
import { Modal, Input, Radio, message } from 'antd'
import { CloudDownloadOutlined, LockOutlined } from '@ant-design/icons'
import axios from 'axios'
import { apiUrl } from '../../config'
import authenticationStore from '../../stores/authenticationStore'

const UNLOCK_PASSWORD = 'Fafu@2026'

const FullCrawlModal = ({ visible, onCancel, onSuccess }) => {
  const [unlockPassword, setUnlockPassword] = useState('')
  const [targetType, setTargetType] = useState('all') // 'all' or 'current'
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleOk = async () => {
    setError('')
    if (!unlockPassword) {
      setError('Vui lòng nhập mật khẩu mở khóa nút!')
      return
    }

    if (unlockPassword !== UNLOCK_PASSWORD) {
      setError('Mật khẩu mở khóa không chính xác!')
      return
    }

    setLoading(true)
    try {
      const appTokenStr = authenticationStore.appToken
      const token = appTokenStr ? JSON.parse(appTokenStr).access_token : ''
      const headers = token ? { Authorization: `Bearer ${token}` } : {}

      if (targetType === 'all') {
        await axios.post(
          `${apiUrl}/api/v1/crawler/crawl/all-full`,
          {},
          { headers }
        )
      } else {
        const currentUser = authenticationStore.currentUser
        await axios.post(
          `${apiUrl}/api/v1/crawler/crawl/start-full`,
          {
            username: currentUser?.username,
            wait: false,
          },
          { headers }
        )
      }

      message.success(
        'Đã kích hoạt tiến trình crawl toàn bộ dữ liệu IMSAT chạy ngầm!'
      )
      setUnlockPassword('')
      setError('')
      if (onSuccess) onSuccess()
      onCancel()
    } catch (err) {
      console.error('Full crawl error:', err)
      message.error('Có lỗi xảy ra khi gọi API crawl toàn bộ dữ liệu!')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setUnlockPassword('')
    setError('')
    onCancel()
  }

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <CloudDownloadOutlined style={{ color: '#1890ff', fontSize: 20 }} />
          <span>Crawl toàn bộ dữ liệu IMSAT</span>
        </div>
      }
      visible={visible}
      onOk={handleOk}
      onCancel={handleClose}
      okText="Bắt đầu Crawl"
      cancelText="Hủy"
      confirmLoading={loading}
      destroyOnClose>
      <div style={{ padding: '8px 0' }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>Phạm vi crawl:</div>
          <Radio.Group
            value={targetType}
            onChange={e => setTargetType(e.target.value)}>
            <Radio value="all">Tất cả người dùng</Radio>
            <Radio value="current">Tài khoản hiện tại</Radio>
          </Radio.Group>
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            Mật khẩu mở khóa tính năng:
          </div>
          <Input.Password
            prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
            placeholder="Nhập mật khẩu"
            value={unlockPassword}
            onChange={e => {
              setUnlockPassword(e.target.value)
              setError('')
            }}
            onPressEnter={handleOk}
          />
        </div>

        {error && (
          <div style={{ color: '#ff4d4f', fontSize: 13, marginTop: 6 }}>
            {error}
          </div>
        )}
      </div>
    </Modal>
  )
}

export default FullCrawlModal
